import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useAuctionStore } from "@/stores/AuctionStore";
  import { computed, onMounted } from "vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationCounter',
  setup(__props) {

  const auctionStore = useAuctionStore();
  const count = computed(() => auctionStore.notifications.length);

  onMounted(auctionStore.initNotifications);

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("span", { class: "notifications-counter" }, _toDisplayString(count.value > 999 ? "···" : count.value), 513)), [
    [_vShow, count.value > 0]
  ])
}
}

})